export interface EventLogEntry {
  id: number
  occurred_at: string
  actor_user: string
  actor_role: string | null
  entity_type: string
  entity_id: string
  action: string
  diff_json: string | null
  source: string | null
  correlation_id: string | null
}

export const ENTITY_TYPES = ['', 'Einsatz', 'FirmaPolicy', 'SchuleStaff', 'Person'] as const
export type EntityType = (typeof ENTITY_TYPES)[number]

export interface EventLogFilter {
  entityType?: EntityType
  entityId?: string
  actor?: string
  limit?: number
}

import { api } from '../../../shared/api'

export async function fetchEventLog(filter: EventLogFilter = {}): Promise<EventLogEntry[]> {
  const qs = new URLSearchParams()
  if (filter.entityType) qs.set('entityType', filter.entityType)
  if (filter.entityId) qs.set('entityId', filter.entityId)
  if (filter.actor) qs.set('actor', filter.actor)
  if (filter.limit) qs.set('limit', String(filter.limit))
  return api.get<EventLogEntry[]>(`/api/eventlog?${qs}`)
}
